import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=298dc2d4&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=298dc2d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dc2d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298dc2d4')) {
      api.createRecord('298dc2d4', component.options)
    } else {
      api.reload('298dc2d4', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=298dc2d4&scoped=true", function () {
      api.rerender('298dc2d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Error.vue"
export default component.exports